import { render, staticRenderFns } from "./policy-form.vue?vue&type=template&id=42bff47e&scoped=true&"
import script from "./policy-form.vue?vue&type=script&lang=js&"
export * from "./policy-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-form.vue?vue&type=style&index=0&id=42bff47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bff47e",
  null
  
)

export default component.exports